import React from 'react';
import moment from 'moment';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import TimelineIcon from '@mui/icons-material/Timeline';
import BarChartIcon from '@mui/icons-material/BarChart';

import { chartWrapper, cardBox, iconWrap, iconGreen, iconPurple, labelText, valueText, tooltipStyles } from '../styles/dashboardStyles';

export default function SightingsChart({ data, total, dailyAverage }) {
  const formatNumber = (num) => (num ? num.toLocaleString() : '0');

  const formatShortNumber = (num) => {
    if (!num) return '0';

    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';

    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';

    if (num >= 1_000) return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';

    return num.toString(); // under 1000
  };

  const formatNumberWithCommas = (num) => (num ? num.toLocaleString() : '0');

  return (
    <div style={chartWrapper}>
      <h4 style={{ margin: 0, paddingLeft: 6, paddingBottom: 8 }}>Processed Sightings</h4>

      <div style={{ display: 'flex', marginBottom: '20px' }}>
        {/* <div style={{ ...cardBox, backgroundColor: '#ECFDF5' }}>
          <div style={iconWrap}>
            <TimelineIcon fontSize='large' style={iconGreen} />
          </div>
          <div style={{ paddingLeft: 10 }}>
            <p style={labelText}>Total Sightings</p>
            <p style={valueText}>{total}</p>
          </div>
        </div> */}

        <div style={{ ...cardBox, backgroundColor: '#F5F3FF' }}>
          <div style={iconWrap}>
            <BarChartIcon fontSize='large' style={iconPurple} />
          </div>
          <div style={{ paddingLeft: 10 }}>
            <p style={labelText}>Daily Average</p>
            <p style={valueText}>{formatNumberWithCommas(dailyAverage)}</p>
          </div>
        </div>
      </div>

      <ResponsiveContainer width='100%' height={250}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray='3 3' stroke='#e2e8f0' />
          <XAxis dataKey='date' stroke='#64748b' tickFormatter={(v) => moment(v).format('MM/DD')} />
          <YAxis stroke='#64748b' tickFormatter={(v) => formatShortNumber(v)} />
          <Tooltip contentStyle={tooltipStyles} formatter={(value) => formatNumberWithCommas(value)} />
          <Line type='monotone' dataKey='count' stroke='#10b981' strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
